import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { createNullObject, PartialWithRequired } from './utils';

export const productAnalyticsBpContextName = 'product_analytics_context';
export const productAnalyticsBpContextSchemaVersion = 133;
export type ProductAnalyticsBpContext = Fields<
  typeof productAnalyticsBpContextName,
  typeof productAnalyticsBpContextSchemaVersion
>;

const defaults = createNullObject([
  'copy',
  'element',
  'flow',
  'modal_name',
  'device_type',
  'is_user_facing_data',
  'scrolling_percentage',
  'entity_type',
]);

export const buildProductAnalyticsBpContext = (
  fields: PartialWithRequired<ProductAnalyticsBpContext, 'feature' | 'location' | 'product'>,
) => {
  return {
    product_analytics_context: new EventContext(
      productAnalyticsBpContextName,
      productAnalyticsBpContextSchemaVersion,
      {
        ...defaults,
        ...fields,
      },
    ),
  };
};
